import React from "react";
import { motion } from "framer-motion";
import styles from "../assets/styles/AboutMe.module.css";
import { FaLaptopCode } from "react-icons/fa";
import wavesdown from "../assets/images/wavesup.svg"


export default function AboutMe() {
  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div className={styles.main}>
    <section className={styles.aboutMeSection}>
      <motion.div 
        className={styles.contentContainer}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className={styles.textSide}>
          <h2 className={styles.title}>ABOUT ME</h2>
          <p className={styles.story}>
  Hi! I’m <strong>Mohammed Elaouja</strong>. My journey started as a <strong>Software Tester at Testio</strong>, where I learned the ins and outs of QA and how software is built and maintained. Working closely with development teams sparked my interest in the creation process behind the applications I was testing.
</p>
<p className={styles.story}>
  Motivated to dive deeper, I enrolled in <strong>ALX Software Engineering</strong> after a couple of years in QA. There, I gained strong foundations in full-stack development, learning how to design, build, and deploy functional software from scratch.
</p>
<p className={styles.story}>
  After completing the program, I continued learning on my own, exploring tools and technologies like <strong>React, Node.js, Python, SQL, Firebase, AWS</strong>, and applying UI/UX principles to create digital products that are both functional and delightful to use.
</p>
<p className={styles.story}>
  When I’m not coding or designing, I enjoy exploring new tech trends, optimizing workflows, and turning ideas into practical, beautiful solutions.
</p>
<p className={styles.story}>
  🙂 Speaks <strong style={{ color: "#db2254" }}>Arabic</strong> & a bit of <strong style={{ color: "#db2254" }}>English</strong>
</p>
        </div>
        <div className={styles.visualSide}>
          <div className={styles.profileWrapper}>
  <div className={styles.initials}><FaLaptopCode size={60} /></div>
</div>
        </div>
      </motion.div>
    </section>
    <img className={styles.upperImg} src={wavesdown}/>
    </div>
  );
}
